/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  PackagesMiniVisual, PackagesMini,
  PackagesMiniLite,
  PackagesMiniTransactional
} from '@thd-olt-component-react/packages-mini';
import { ThdRecsFbt } from '@thd-olt-component-react/thd-recs-fbt';
import proptypes from 'prop-types';
const { bool, string } = proptypes;
import { Row } from '@thd-olt-component-react/core-ui';
import { extend } from '@thd-nucleus/data-sources';
import {
  RENDER_THD_RECS, RENDER_TRANSACTIONAL, RENDER_VISUAL, RENDER_CO_WORK
} from '../constants/index';
import ZoneCard from './zone-card';

const PackagesMiniAbTest = ({ itemId = '', renderComponent = '', name = '', noPipSpacing = false, ...props }) => {
  switch (renderComponent) {
  case RENDER_THD_RECS:
    return (
      <Row>
        <ThdRecsFbt
          apiName="fbt_test"
          itemId={itemId}
          name={name}
          noPipSpacing={noPipSpacing}
          errorBoundary
          hydrator={{
            className: 'grid',
            tag: ZoneCard,
            id: 'thd-recs-fbt'
          }}
        />
      </Row>
    );
  case RENDER_VISUAL:
    return (
      <PackagesMiniVisual
        itemId={itemId}
        dynamic={{
          pageType: 'pip'
        }}
        hydrator={{
          className: 'grid',
          tag: ZoneCard
        }}
        {...props}
      />
    );

  case RENDER_TRANSACTIONAL:
    return (
      <PackagesMiniTransactional
        itemId={itemId}
        dynamic={{
          pageType: 'pip'
        }}
        hydrator={{
          className: 'grid',
          tag: ZoneCard
        }}
        {...props}
      />
    );

  case RENDER_CO_WORK:
    return (
      <PackagesMiniLite
        itemId={itemId}
        dynamic={{
          pageType: 'pip'
        }}
        hydrator={{
          className: 'grid',
          tag: ZoneCard
        }}
        {...props}
      />
    );

  default:
    return (
      <PackagesMini
        itemId={itemId}
        dynamic={{
          pageType: 'pip'
        }}
        hydrator={{
          className: 'grid',
          tag: ZoneCard
        }}
        {...props}
      />
    );
  }
};

PackagesMiniAbTest.dataModel = extend(
  PackagesMiniVisual,
  ThdRecsFbt,
  PackagesMini,
  PackagesMiniLite,
  PackagesMiniTransactional
);
PackagesMiniAbTest.propTypes = {
  itemId: string,
  renderComponent: string,
  name: string,
  noPipSpacing: bool
};

PackagesMiniAbTest.displayName = 'PackagesMiniAbTest';

export { PackagesMiniAbTest };